import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { RegisterComponent } from './components/register/register.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SplashComponent } from './components/splash/splash.component';

export const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'splash',
    component: SplashComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'visitor-badge/:id',
    loadComponent: () =>
      import('./components/visitor-badge/visitor-badge.component').then(
        (c) => c.VisitorBadgeComponent
      ),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'host-users',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/host/host.module').then((m) => m.HostModule),
  },
  {
    path: 'master-data',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/masterdata/masterdata.module').then(
        (m) => m.MasterdataModule
      ),
  },
  {
    path: 'roles-permissions',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/roles-permissions/roles-permissions.module').then(
        (m) => m.RolesPermissionsModule
      ),
  },


  {
    path: 'customer',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/customer/customer.module').then((m) => m.CustomerModule),
  },

  {
    path: 'customerSite',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/customer-site/customer-site.module').then((m) => m.CustomerSiteModule),
  },




  {
    path: 'product',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/product/product.module').then((m) => m.ProductModule),
  },




  {
    path: 'productPlan',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/productplan/productplan.module').then((m) => m.ProductplanModule),
  },


  {
    path: 'subscription',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/subscription/subscription.module').then((m) => m.SubscriptionModule),
  },


  {
    path: 'notifications',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/notifications/notifications.module').then(
        (m) => m.NotificationsModule
      ),
  },
  {
    path: 'reports',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'settings',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/settings/settings.module').then((m) => m.SettingsModule),
  },
];
